import React, { useCallback } from 'react';
import { ReferenceField } from '@1po/1po-bff-fe-spec/generated/estimate/request/UpdateReference';
import { MyStoreReference } from '@1po/1po-bff-fe-spec/generated/estimate/response/AutocompleteSearchReferencesResponse';
import { ReferenceSearchParams } from 'domains/estimate/Estimate.types';
import { capitalize, Pipeline, Text } from 'UI';
import { SearchMenu, SItem } from './Autocomplete.styled';

interface AutocompleteMenuProps {
  results: MyStoreReference[];
  inputValue: string;
  onClick: (
    label: string,
    id: string,
    code: string,
    clientPriceVatExcluded: string,
    garagePriceVatExcluded: string,
  ) => () => void;
  search: ReferenceSearchParams;
  setSearch: React.Dispatch<React.SetStateAction<ReferenceSearchParams>>;
  field: ReferenceField;
}

const ReferenceAutocompleteMenu = ({
  results,
  inputValue,
  onClick,
  search,
  setSearch,
  field,
}: AutocompleteMenuProps) => {
  const valueToCheck = inputValue.replaceAll(/[^a-zA-Z\s]/g, '');
  const check = new RegExp(`(?=${valueToCheck})|(?<=${valueToCheck})`, 'gi');

  const handleBlurMenu = (e: React.FocusEvent<HTMLLIElement>) => {
    if (search?.focusMenu !== undefined && !e?.relatedTarget?.id?.includes('search-menu')) {
      setSearch({ ...search, open: false, focusMenu: undefined });
    }
  };

  const handleEscPress = useCallback(
    (event: { key: string }) => {
      if (event.key === 'Escape') {
        setSearch({ ...search, open: false, focusMenu: 0 });
      }
    },
    [search, setSearch],
  );

  return (
    <SearchMenu onKeyDown={handleEscPress} onMouseDown={(e) => e.preventDefault()}>
      {results.map((fulltext, index) => (
        <React.Fragment key={`keywords-${fulltext.referenceId}-${fulltext.referenceNumber}`}>
          <SItem
            onClick={onClick(
              fulltext.designation ?? '',
              fulltext.referenceId ?? '',
              fulltext.referenceNumber ?? '',
              fulltext.clientPriceVatExcluded ?? '',
              fulltext.garagePriceVatExcluded ?? '',
            )}
            key={`menu-item-${fulltext.referenceId}-${fulltext.referenceNumber}`}
            id={`search-menu-${index}`}
            onBlur={handleBlurMenu}
          >
            {((field === 'NAME' ? fulltext.designation : fulltext.referenceNumber) ?? '')
              .split(check)
              ?.map((segment, idx) => (
                <Text
                  key={`segment-${segment}`}
                  type={segment === inputValue ? 'search_result_base' : 'search_result_highlighted'}
                  cursor={'pointer'}
                >
                  {idx === 0 ? capitalize(segment) : segment}
                </Text>
              ))}
          </SItem>
          {index + 1 !== results.length && <Pipeline horizontal size={'100%'} />}
        </React.Fragment>
      ))}
    </SearchMenu>
  );
};
export default ReferenceAutocompleteMenu;
